import React from 'react'
import Grid from '@material-ui/core/Grid'
import { withRouter, RouteComponentProps } from 'react-router'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import { Error } from 'types'
import Input from 'components/shared/Input'

interface IProps extends RouteComponentProps {
  data: any
  error: Error | string
  handleCustomerInfoChange: (customer: any) => void
  handleConfirm: () => void
  handleCancel: () => void
  registerAnother: () => void
  registered: boolean
}

interface IState {
  editMode: boolean
  customer: any
}

const nonEditableInfo = [
  {
    label: 'DeviceID',
    field: 'deviceID',
  },
  {
    label: 'Ship To',
    field: 'id',
  },
]

const editableInfo = [
  {
    label: 'Zone',
    field: 'region',
  },
  {
    label: 'Customer',
    field: 'name1',
  },
  {
    label: 'Address',
    field: 'street1',
  },
  {
    label: 'TankId',
    field: 'tankId',
  },
  {
    label: 'Product',
    field: 'product',
  },
]

const isDataInvalid = (data: any): boolean => editableInfo.some(({ field }) => !data[field])

const isCustomerChanged = (original: any, copy: any): boolean =>
  editableInfo.some(({ field }) => original[field] !== copy[field])

class ConfirmationScreen extends React.PureComponent<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      customer: this.props.data,
    }
  }

  _toggleEditMode = () =>
    this.setState({
      ...this.state,
      editMode: !this.state.editMode,
    })

  _handleEditCancel = () =>
    this.setState({
      ...this.state,
      editMode: false,
      customer: this.props.data,
    })

  _handleEditSave = () => {
    this.props.handleCustomerInfoChange(this.state.customer)
    this._toggleEditMode()
  }

  _handleCustomerInfoChange = (field: string) => (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      ...this.state,
      customer: {
        ...this.state.customer,
        [field]: evt.currentTarget.value,
      },
    })
  }

  render() {
    const { error, history, data, handleConfirm, handleCancel, registered, registerAnother } = this.props
    const { editMode, customer } = this.state
    return (
      <Grid container direction="column">
        <Grid container item justify="center">
          <Box mb={{ xs: 5 }}>
            <Typography variant="h2" color="secondary">
              {registered ? 'Registration successful!' : editMode ? 'Edit Customer' : 'Confirm Registration'}
            </Typography>
          </Box>
        </Grid>
        <Grid container direction="column" spacing={3} style={{ backgroundColor: '#fff' }}>
          <Box p={{ xs: 3, md: 4, lg: 6 }}>
            {!editMode && !registered && (
              <Grid container justify="flex-end">
                <img className="clickable" src="/images/icons/edit.svg" onClick={this._toggleEditMode} />
              </Grid>
            )}
            <Grid item>
              <Typography variant="body1" color="error">
                {error}
              </Typography>
            </Grid>
            {nonEditableInfo.map(({ label, field }) => (
              <Box key={field} my={{ xs: 2 }}>
                <Grid container alignItems="flex-end">
                  <Grid item xs={4}>
                    <Typography variant="h4" color="secondary">
                      {label}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="h4" color="secondary">
                      {data[field]}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            ))}
            {editableInfo.map(({ label, field }) => (
              <Box key={field} my={{ xs: 2 }}>
                <Grid container key={field}>
                  <Grid item xs={4}>
                    <Typography variant="h4" color="secondary">
                      {label}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    {editMode ? (
                      <Input value={customer[field]} onChange={this._handleCustomerInfoChange(field)} margin="none" />
                    ) : (
                      <Typography variant="h4" color="secondary">
                        {customer[field]}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Box>
            ))}
            <Box pt={{ xs: 2, sm: 4 }}>
              {!registered && !editMode && (
                <Grid container justify="space-evenly">
                  <Grid item xs={4}>
                    <Button fullWidth variant="contained" onClick={handleCancel}>
                      <Typography variant="h4" color="primary">
                        Back
                      </Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={4}>
                    <Button fullWidth variant="contained" disabled={isDataInvalid(customer)} onClick={handleConfirm}>
                      <Typography variant="h4" color="primary">
                        Confirm
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
              )}
              {!registered && editMode && (
                <Grid container justify="space-evenly">
                  <Grid item xs={4}>
                    <Button fullWidth variant="contained" onClick={this._handleEditCancel}>
                      <Typography variant="h4" color="primary">
                        Cancel
                      </Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={4}>
                    <Button
                      fullWidth
                      variant="contained"
                      disabled={!isCustomerChanged(data, customer)}
                      onClick={this._handleEditSave}
                    >
                      <Typography variant="h4" color="primary">
                        Save
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
              )}
              {registered && (
                <Grid container justify="space-evenly">
                  <Grid item xs={4}>
                    <Button fullWidth variant="contained" onClick={() => history.push('/')}>
                      <Typography variant="h4" color="primary">
                        Home
                      </Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={4}>
                    <Button fullWidth variant="contained" onClick={registerAnother}>
                      <Typography variant="h4" color="primary">
                        Register Another
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    )
  }
}

export default withRouter(ConfirmationScreen)
